module.exports = __webpack_public_path__ + "821e888eaf030e0e4cae1e54c235c70b.pdf";